/**
 * Catálogos del módulo «Webchats», compartidos por el API y la web.
 *
 * Son copias de lo que el webchat genérico (webchat-external-generic) acepta,
 * leídas en el release b393106: lib/telefono.js (países), public/iconos.js
 * (íconos), lib/tema.js (columnas del tema, valores de ISOFT y pares de
 * contraste). Si el webchat cambia su lista, se cambia acá en el mismo release.
 */
/** Zona de Cloudflare donde viven los subdominios de los webchats. */
export const ZONA_WEBCHAT = "ginabot.chat";
export const PAISES_WEBCHAT = [
    { codigo: "502", nombre: "Guatemala", iso: "GT", largo: 8 },
    { codigo: "503", nombre: "El Salvador", iso: "SV", largo: 8 },
    { codigo: "504", nombre: "Honduras", iso: "HN", largo: 8 },
    { codigo: "505", nombre: "Nicaragua", iso: "NI", largo: 8 },
    { codigo: "506", nombre: "Costa Rica", iso: "CR", largo: 8 },
    { codigo: "507", nombre: "Panamá", iso: "PA", largo: 8 },
    { codigo: "52", nombre: "México", iso: "MX", largo: 10 },
    { codigo: "1", nombre: "Estados Unidos", iso: "US", largo: 10 },
    { codigo: "1", nombre: "Canadá", iso: "CA", largo: 10 },
    { codigo: "1787", nombre: "Puerto Rico", iso: "PR", largo: 7 },
    { codigo: "1", nombre: "República Dominicana", iso: "DO", largo: 10 },
    { codigo: "509", nombre: "Haití", iso: "HT", largo: 8 },
    { codigo: "53", nombre: "Cuba", iso: "CU", largo: 8 },
    { codigo: "57", nombre: "Colombia", iso: "CO", largo: 10 },
    { codigo: "58", nombre: "Venezuela", iso: "VE", largo: 10 },
    { codigo: "593", nombre: "Ecuador", iso: "EC", largo: 9 },
    { codigo: "51", nombre: "Perú", iso: "PE", largo: 9 },
    { codigo: "591", nombre: "Bolivia", iso: "BO", largo: 8 },
    { codigo: "56", nombre: "Chile", iso: "CL", largo: 9 },
    { codigo: "54", nombre: "Argentina", iso: "AR", largo: 10 },
    { codigo: "598", nombre: "Uruguay", iso: "UY", largo: 8 },
    { codigo: "595", nombre: "Paraguay", iso: "PY", largo: 9 },
    { codigo: "55", nombre: "Brasil", iso: "BR", largo: 11 },
    { codigo: "34", nombre: "España", iso: "ES", largo: 9 },
    { codigo: "39", nombre: "Italia", iso: "IT", largo: 10 },
    { codigo: "33", nombre: "Francia", iso: "FR", largo: 9 },
    { codigo: "49", nombre: "Alemania", iso: "DE", largo: 10 },
    { codigo: "44", nombre: "Reino Unido", iso: "GB", largo: 10 },
    { codigo: "351", nombre: "Portugal", iso: "PT", largo: 9 },
    { codigo: "31", nombre: "Países Bajos", iso: "NL", largo: 9 },
    { codigo: "32", nombre: "Bélgica", iso: "BE", largo: 9 },
    { codigo: "41", nombre: "Suiza", iso: "CH", largo: 9 },
];
/** Códigos de país distintos (el +1 lo comparten tres países). */
export const CODIGOS_PAIS_WEBCHAT = [...new Set(PAISES_WEBCHAT.map((p) => p.codigo))];
/* ── Íconos (public/iconos.js) ────────────────────────────────────────── */
/** Trazos de 24x24 (stroke, sin relleno), en el estilo de Lucide. */
export const ICONOS_WEBCHAT_TRAZOS = {
    gota: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
    reloj: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 7v5l3 2",
    casa: "M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z",
    factura: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1ZM16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8M12 17.5v-11",
    documento: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7ZM14 2v4a2 2 0 0 0 2 2h4M10 9H8M16 13H8M16 17H8",
    alerta: "M21.73 18l-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3M12 9v4M12 17h.01",
    auricular: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
    calendario: "M8 2v4M16 2v4M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2ZM3 10h18",
    ubicacion: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0M9 10a3 3 0 1 0 6 0a3 3 0 1 0-6 0",
    tienda: "M3 9l1.5-5h15L21 9M3 9h18M3 9v1a3 3 0 0 0 6 0a3 3 0 0 0 6 0a3 3 0 0 0 6 0V9M5 12.5V21h14v-8.5M10 21v-5h4v5",
    "estado-caso": "M9 3h6a1 1 0 0 1 1 1v2H8V4a1 1 0 0 1 1-1zM8 5H6a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 14l2 2 4-4",
    "bolsa-horas": "M5 22h14M5 2h14M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2",
    salvavidas: "M2 12a10 10 0 1 0 20 0a10 10 0 1 0-20 0M8 12a4 4 0 1 0 8 0a4 4 0 1 0-8 0M4.93 4.93l4.24 4.24M14.83 9.17l4.24-4.24M14.83 14.83l4.24 4.24M9.17 14.83l-4.24 4.24",
    cronometro: "M10 2h4M12 14l3-3M4 14a8 8 0 1 0 16 0a8 8 0 1 0-16 0",
    tarjeta: "M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zM2 10h20",
    agente: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 3a4 4 0 1 0 0 8a4 4 0 0 0 0-8z",
    chat: "M21 12a8 8 0 0 1-8 8H7l-4 3v-5.5A8 8 0 1 1 21 12z",
    rayo: "M13 2 3 14h9l-1 8 10-12h-9z",
    menu: "M12 5h.01M12 12h.01M12 19h.01",
    flecha: "m9 18 6-6-6-6",
    enviar: "M12 19V5M5 12l7-7 7 7",
    avion: "M22 2 11 13M22 2l-7 20-4-9-9-4z",
    mas: "M12 5v14M5 12h14",
    clip: "M21.4 11.05 12.25 20.2a5.5 5.5 0 0 1-7.78-7.78l9.19-9.19a3.67 3.67 0 0 1 5.18 5.18l-9.2 9.19a1.83 1.83 0 0 1-2.59-2.59l8.49-8.48",
    microfono: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3zM19 10v2a7 7 0 0 1-14 0v-2M12 19v3",
};
export const ICONOS_WEBCHAT = Object.keys(ICONOS_WEBCHAT_TRAZOS);
/** Lo mismo que el CHECK CK_WEXTA_TRAZO de la base, más el tope de largo. */
export const RE_ICONO_TRAZO = /^[MmLlHhVvCcSsQqTtAaZz0-9 ,.-]{1,600}$/;
/**
 * Familias de Google Fonts que se pueden elegir. GOOGLE_FONTS no se escribe a
 * mano: lo arma el servidor con googleFontsDe() a partir de las elegidas.
 */
export const FUENTES_PERMITIDAS = [
    { familia: "Inter", pesos: [400, 500, 600, 700] },
    { familia: "Kanit", pesos: [400, 500, 600] },
    { familia: "IBM Plex Mono", pesos: [400, 500] },
    { familia: "Poppins", pesos: [400, 500, 600, 700] },
    { familia: "Space Grotesk", pesos: [500, 600, 700] },
    { familia: "Roboto", pesos: [400, 500, 700] },
    { familia: "Open Sans", pesos: [400, 600, 700] },
    { familia: "Lato", pesos: [400, 700] },
    { familia: "Montserrat", pesos: [400, 500, 600, 700] },
    { familia: "Nunito", pesos: [400, 600, 700] },
    { familia: "Work Sans", pesos: [400, 500, 600] },
    { familia: "DM Sans", pesos: [400, 500, 700] },
    { familia: "Manrope", pesos: [400, 500, 600, 700] },
    { familia: "Rubik", pesos: [400, 500, 600] },
    { familia: "Source Sans 3", pesos: [400, 600, 700] },
    { familia: "Roboto Mono", pesos: [400, 500] },
    { familia: "JetBrains Mono", pesos: [400, 500] },
];
export const FAMILIAS_PERMITIDAS = FUENTES_PERMITIDAS.map((f) => f.familia);
/**
 * La query de fonts.googleapis.com/css2 (sin el «?») para las familias dadas,
 * en el formato que acepta lib/tema.js (googleFontsSegura). Ignora repetidas y
 * familias fuera del catálogo. Devuelve null si no queda ninguna.
 */
export function googleFontsDe(familias) {
    const partes = [];
    const vistas = new Set();
    for (const familia of familias) {
        if (!familia || vistas.has(familia))
            continue;
        const fuente = FUENTES_PERMITIDAS.find((f) => f.familia === familia);
        if (!fuente)
            continue;
        vistas.add(familia);
        partes.push(`family=${fuente.familia.replaceAll(" ", "+")}:wght@${fuente.pesos.join(";")}`);
    }
    if (!partes.length)
        return null;
    return `${partes.join("&")}&display=swap`;
}
/* ── Motor del bot (CANAL.NAMEBOT) ────────────────────────────────────── */
/** Lista fija: la clave se ve en el backoffice, la URL va a CANAL.NAMEBOT. */
export const NAMEBOTS_WEBCHAT = {
    "masterbot-wp": "https://masterbot-wp-7ccawkpiyq-uk.a.run.app/masterbot-wp",
};
export const NAMEBOT_CLAVES = Object.keys(NAMEBOTS_WEBCHAT);
/** La clave de una URL de NAMEBOT, o null si no está en la lista. */
export function namebotDeUrl(url) {
    if (!url)
        return null;
    const par = Object.entries(NAMEBOTS_WEBCHAT).find(([, u]) => u === url);
    return par ? par[0] : null;
}
const KB = 1024;
const icono = (ranura, nombre, lado) => ({
    ranura,
    nombre,
    medida: { tipo: "fijo", lado },
    salida: ["image/png"],
    maxBytes: 512 * KB,
    descripcion: `PNG cuadrado; se guarda en ${lado}x${lado}`,
});
/**
 * Las ranuras que se suben desde el backoffice. favicon_ico no se ofrece:
 * /favicon.ico del webchat cae a favicon_32.
 */
export const RANURAS_WEBCHAT = [
    {
        ranura: "logo",
        nombre: "Logo",
        medida: { tipo: "caja", anchoMax: 1024, altoMax: 512 },
        salida: ["image/png", "image/webp"],
        maxBytes: 512 * KB,
        descripcion: "PNG o WebP, hasta 1024x512 (se reduce, nunca se agranda)",
    },
    {
        ranura: "logo_claro",
        nombre: "Logo sobre fondo oscuro",
        medida: { tipo: "caja", anchoMax: 1024, altoMax: 512 },
        salida: ["image/png", "image/webp"],
        maxBytes: 512 * KB,
        descripcion: "PNG o WebP, hasta 1024x512 (se reduce, nunca se agranda)",
    },
    {
        ranura: "avatar",
        nombre: "Avatar del asistente",
        medida: { tipo: "cuadrado", ladoMin: 128, ladoMax: 512 },
        salida: ["image/png", "image/webp"],
        maxBytes: 512 * KB,
        descripcion: "Cuadrado de 128 a 512 px, PNG o WebP",
    },
    {
        ranura: "patron",
        nombre: "Fondo del chat",
        medida: { tipo: "patron", ladoMayorMax: 1600, ladoMenorMin: 200 },
        salida: ["image/webp"],
        maxBytes: 300 * KB,
        descripcion: "WebP; lado mayor hasta 1600 (se reduce), lado menor desde 200; hasta 300 KB",
    },
    {
        ranura: "link",
        nombre: "Imagen del link de WhatsApp",
        medida: { tipo: "link", proporciones: [1, 1.91], tolerancia: 0.02, ladoMenorMin: 500, ladoMayorMax: 1600 },
        salida: ["image/jpeg"],
        maxBytes: 300 * KB,
        descripcion: "JPEG 1:1 o 1,91:1; lado menor desde 500, lado mayor hasta 1600; hasta 300 KB",
    },
    icono("favicon_16", "Favicon 16", 16),
    icono("favicon_32", "Favicon 32", 32),
    icono("apple_touch", "Ícono de Apple", 180),
    icono("icono_192", "Ícono 192", 192),
    icono("icono_512", "Ícono 512", 512),
    icono("maskable_512", "Ícono adaptable 512", 512),
    icono("badge", "Insignia de avisos", 96),
];
export const RANURAS_SUBIBLES = RANURAS_WEBCHAT.map((r) => r.ranura);
export function ranuraWebchat(ranura) {
    return RANURAS_WEBCHAT.find((r) => r.ranura === ranura);
}
const color = (respaldo) => ({ tipo: "color", respaldo });
const texto = (max, respaldo) => ({ tipo: "texto", max, respaldo });
const entero = (min, max, respaldo) => ({ tipo: "entero", min, max, respaldo });
const bool = (respaldo) => ({ tipo: "bool", respaldo });
const opcion = (valores, respaldo) => ({ tipo: "enum", valores, respaldo });
const iconoCol = (respaldo) => ({ tipo: "icono", respaldo });
const fuente = (respaldo) => ({ tipo: "fuente", respaldo });
/**
 * Columnas del tema que se editan desde el backoffice, con su validador y el
 * valor de ISOFT (fila IDCANAL = 0) que el webchat usa cuando la base no
 * responde. Quedan afuera PATRON_URL (siempre NULL en canales nuevos),
 * GOOGLE_FONTS (lo arma el servidor) y TEXTOS (se conserva; en el alta
 * queda NULL).
 */
export const TEMA_COLUMNAS = {
    NOMBRE_MARCA: texto(60, "ISOFT"),
    NOMBRE_CORTO: texto(30, "ISOFT"),
    NOMBRE_ASISTENTE: texto(40, "Gina"),
    TITULO_PAGINA: texto(80, "ISOFT · Webchat de clientes"),
    TITULO_BANDEJA: texto(80, "Mensajes"),
    DESCRIPCION: texto(160, "Converse con Gina, la asistente virtual de ISOFT, y con un ingeniero de soporte cuando lo necesite."),
    IDIOMA: { tipo: "idioma", respaldo: "es-GT" },
    TRATAMIENTO: opcion(["tu", "usted", "vos"], "usted"),
    URL_TERMINOS: { tipo: "url", respaldo: null },
    URL_PRIVACIDAD: { tipo: "url", respaldo: null },
    MOSTRAR_LOGO: bool(1),
    LOGO_ALTO: entero(12, 48, 24),
    MOSTRAR_AVATAR: bool(1),
    AVATAR_FORMA: opcion(["circulo", "redondeado", "cuadrado"], "cuadrado"),
    MOSTRAR_VERIFICADO: bool(1),
    CABECERA_TITULO: opcion(["logo", "marca", "asistente"], "asistente"),
    COLOR_PRIMARIO: color("#2A8FD9"),
    COLOR_PRIMARIO_HOVER: color("#47B5FF"),
    COLOR_PRIMARIO_PROFUNDO: color("#0A1931"),
    COLOR_PRIMARIO_CLARO: color("#47B5FF"),
    COLOR_PRIMARIO_TINTE: color("#E5F5FF"),
    COLOR_SOBRE_PRIMARIO: color("#0A1931"),
    COLOR_ACENTO: color("#47B5FF"),
    COLOR_TEXTO: color("#0A1931"),
    COLOR_TEXTO_2: color("#3B475A"),
    COLOR_APAGADO: color("#7A7575"),
    COLOR_TENUE: color("#716C6C"),
    COLOR_LINEA: color("#E2E3E6"),
    COLOR_SUPERFICIE: color("#FFFFFF"),
    COLOR_FONDO: color("#F0F0F0"),
    COLOR_OK: color("#2EAA68"),
    COLOR_ALERTA: color("#C0392B"),
    COLOR_ESPERA: color("#E0A526"),
    THEME_COLOR: color("#FFFFFF"),
    CABECERA_FONDO: color("#FFFFFF"),
    CABECERA_FONDO_2: color("#FFFFFF"),
    CABECERA_TEXTO: color("#0A1931"),
    CABECERA_ICONOS: color("#0A1931"),
    AVATAR_FONDO: color("#0A1931"),
    HILO_FONDO: color("#F4F6F9"),
    HILO_FONDO_2: color("#F4F6F9"),
    PATRON: opcion(["cuadricula", "imagen", "ninguno"], "imagen"),
    PATRON_COLOR: color("#0A1931"),
    PATRON_OPACIDAD: { tipo: "decimal", min: 0, max: 0.5, decimales: 3, respaldo: 0.045 },
    PATRON_TAM: entero(8, 1200, 687),
    BURBUJA_PROPIA_FONDO: color("#0A1931"),
    BURBUJA_PROPIA_TEXTO: color("#FFFFFF"),
    BURBUJA_AJENA_FONDO: color("#FFFFFF"),
    BURBUJA_AJENA_TEXTO: color("#0A1931"),
    BURBUJA_AJENA_BORDE: color("#E2E3E6"),
    RADIO_BURBUJA: entero(0, 32, 6),
    BOTON_FONDO: color("#47B5FF"),
    BOTON_TEXTO: color("#0A1931"),
    BOTON_HOVER: color("#2A8FD9"),
    RADIO_BOTON: entero(0, 40, 6),
    ICONO_ENVIAR: iconoCol("enviar"),
    ICONO_ADJUNTAR: iconoCol("mas"),
    ICONO_MICROFONO: iconoCol("microfono"),
    OPCION_TEXTO: color("#0A1931"),
    OPCION_FONDO: color("#FFFFFF"),
    OPCION_BORDE: color("#2A8FD9"),
    OPCION_HOVER: color("#47B5FF"),
    OPCION_MAX: entero(1, 10, 5),
    RAYITO_VISIBLE: bool(null),
    RAYITO_ICONO: iconoCol("rayo"),
    RAYITO_COLOR: color("#0A1931"),
    HOJA_FONDO: color("#FFFFFF"),
    ATAJO_FONDO: color("#E5F5FF"),
    ATAJO_ICONO_COLOR: color("#2A8FD9"),
    ATAJO_TEXTO: color("#0A1931"),
    ATAJO_COLUMNAS: entero(2, 4, 3),
    ASESOR_VISIBLE: bool(1),
    ASESOR_MENSAJE: texto(200, "Hablar con un ingeniero"),
    ASESOR_ICONO: iconoCol("agente"),
    ASESOR_COLOR_FONDO: color("#0A1931"),
    ASESOR_COLOR_ICONO: color("#47B5FF"),
    ASESOR_COLOR_TEXTO: color("#FFFFFF"),
    BARRA_FONDO: color("#0A1931"),
    BARRA_TEXTO: color("#FFFFFF"),
    ORBE_COLOR_1: color("#47B5FF"),
    ORBE_COLOR_2: color("#2A8FD9"),
    ORBE_COLOR_3: color("#0A1931"),
    PIN_MAPA: color("#2A8FD9"),
    LANZADOR_FONDO: color("#0A1931"),
    LANZADOR_POSICION: opcion(["derecha", "izquierda"], "derecha"),
    FUENTE_TEXTO: fuente("Inter"),
    FUENTE_DISPLAY: fuente("Inter"),
    PESO_DISPLAY: entero(100, 900, 600),
    FUENTE_TITULO: fuente("Kanit"),
    PESO_TITULO: entero(100, 900, 500),
    FUENTE_MONO: fuente("IBM Plex Mono"),
    RADIO_TARJETA: entero(0, 32, 4),
    RADIO_CAMPO: entero(0, 32, 6),
};
export const COLUMNAS_TEMA = Object.keys(TEMA_COLUMNAS);
/** Columnas del tema que arma o conserva el servidor (no se editan). */
export const COLUMNAS_TEMA_SERVIDOR = ["PATRON_URL", "GOOGLE_FONTS", "TEXTOS"];
/** Columnas de fuente, para armar GOOGLE_FONTS. */
export const COLUMNAS_FUENTE = ["FUENTE_TEXTO", "FUENTE_DISPLAY", "FUENTE_TITULO", "FUENTE_MONO"];
/* ── Color: contraste WCAG (lib/tema.js) ──────────────────────────────── */
/** Pares texto/fondos que tienen que leerse (WCAG AA). */
export const PARES_CONTRASTE = [
    ["COLOR_SOBRE_PRIMARIO", ["COLOR_PRIMARIO"]],
    ["BOTON_TEXTO", ["BOTON_FONDO", "BOTON_HOVER"]],
    ["BURBUJA_PROPIA_TEXTO", ["BURBUJA_PROPIA_FONDO"]],
    ["BURBUJA_AJENA_TEXTO", ["BURBUJA_AJENA_FONDO"]],
    ["CABECERA_TEXTO", ["CABECERA_FONDO", "CABECERA_FONDO_2"]],
    ["BARRA_TEXTO", ["BARRA_FONDO"]],
    ["ASESOR_COLOR_TEXTO", ["ASESOR_COLOR_FONDO"]],
    ["OPCION_TEXTO", ["OPCION_FONDO", "OPCION_HOVER"]],
    ["ATAJO_TEXTO", ["HOJA_FONDO"]],
    ["COLOR_TEXTO", ["COLOR_SUPERFICIE"]],
];
export const MIN_CONTRASTE = 4.5;
const RE_HEX6 = /^#[0-9a-fA-F]{6}$/;
function canales(hex) {
    if (!RE_HEX6.test(hex))
        throw new Error("color inválido");
    const h = hex.slice(1);
    return [
        Number.parseInt(h.slice(0, 2), 16),
        Number.parseInt(h.slice(2, 4), 16),
        Number.parseInt(h.slice(4, 6), 16),
    ];
}
function hexDe([r, g, b]) {
    const p = (n) => Math.max(0, Math.min(255, Math.round(n))).toString(16).padStart(2, "0");
    return `#${p(r)}${p(g)}${p(b)}`.toUpperCase();
}
/** Luminancia relativa WCAG 2.x de un #RRGGBB. */
export function luminancia(hex) {
    const [r, g, b] = canales(hex).map((c) => {
        const s = c / 255;
        return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
    });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
/** Relación de contraste WCAG 2.x, de 1 a 21. */
export function contraste(a, b) {
    const la = luminancia(a);
    const lb = luminancia(b);
    return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
}
/** Mezcla lineal en sRGB: t = 0 es `a`, t = 1 es `b`. */
export function mezclar(a, b, t) {
    const x = canales(a);
    const y = canales(b);
    return hexDe([x[0] + (y[0] - x[0]) * t, x[1] + (y[1] - x[1]) * t, x[2] + (y[2] - x[2]) * t]);
}
/** El candidato que mejor se lee sobre TODOS los fondos (maximiza el peor contraste). */
export function mejorSobre(fondos, candidatos) {
    let mejor = candidatos[0] ?? "#000000";
    let puntaje = -1;
    for (const c of candidatos) {
        const p = Math.min(...fondos.map((f) => contraste(c, f)));
        if (p > puntaje) {
            mejor = c;
            puntaje = p;
        }
    }
    return mejor;
}
/** Hover derivado: más oscuro si el color es claro, más claro si es oscuro. */
export function derivarHover(hex) {
    return luminancia(hex) > 0.18 ? mezclar(hex, "#000000", 0.16) : mezclar(hex, "#FFFFFF", 0.18);
}
/** Tinte: un fondo suave del mismo tono. */
export function derivarTinte(hex) {
    return mezclar(hex, "#FFFFFF", 0.9);
}
/** El valor de ISOFT (respaldo del webchat) de cada columna editable. */
export function temaRespaldo() {
    const out = {};
    for (const col of COLUMNAS_TEMA)
        out[col] = TEMA_COLUMNAS[col].respaldo;
    return out;
}
/**
 * El tema que pinta el webchat: columna por columna, la del canal; si es NULL,
 * la de la fila 0; si también, el respaldo de ISOFT (lib/tema.js).
 */
export function temaEfectivo(canal, fila0) {
    const out = {};
    for (const col of COLUMNAS_TEMA) {
        out[col] = canal?.[col] ?? fila0?.[col] ?? TEMA_COLUMNAS[col].respaldo;
    }
    return out;
}
/** Los pares de un tema completo que no llegan al contraste mínimo. */
export function problemasDeContraste(tema) {
    const problemas = [];
    const textoBase = typeof tema.COLOR_TEXTO === "string" && RE_HEX6.test(tema.COLOR_TEXTO) ? tema.COLOR_TEXTO : "#0A1931";
    const oscuro = luminancia(textoBase) < 0.2 ? textoBase.toUpperCase() : "#0A1931";
    for (const [texto, fondos] of PARES_CONTRASTE) {
        const t = tema[texto];
        const fs = fondos.map((f) => tema[f]);
        if (typeof t !== "string" || !RE_HEX6.test(t))
            continue;
        if (!fs.every((f) => typeof f === "string" && RE_HEX6.test(f)))
            continue;
        const peor = Math.min(...fs.map((f) => contraste(t, f)));
        if (peor < MIN_CONTRASTE) {
            problemas.push({
                texto,
                fondos: [...fondos],
                ratio: Math.round(peor * 100) / 100,
                minimo: MIN_CONTRASTE,
                sugerencia: mejorSobre(fs, [oscuro, "#FFFFFF", "#000000"]),
            });
        }
    }
    return problemas;
}
/* ── Estados del módulo ───────────────────────────────────────────────── */
export const ESTADOS_WEBCHAT = ["ACTIVO", "SUSPENDIDO", "BAJA", "ALTA_EN_CURSO", "ALTA_CON_ERROR"];
/** WEBCHAT_EXT_DOMINIO.ESTADO → estado del módulo. */
export function estadoDeDominio(estado) {
    if (estado === 2)
        return "SUSPENDIDO";
    if (estado === 0)
        return "BAJA";
    return "ACTIVO";
}
/** Feature flags del módulo (bo_feature_flag.flag_key). */
export const FLAG_COMPANIES_WEBCHAT = "webchat_social_isoft";
export const FLAG_RELEASE_FASE1 = "webchat_release_fase1";
//# sourceMappingURL=webchat-catalogos.js.map